// extracted by mini-css-extract-plugin
export default {"Bread":"📚19-10-2BxUl0"};